import { render } from "./linkTo.vue?vue&type=template&id=a1d2b666"
import script from "./linkTo.vue?vue&type=script&lang=js"
export * from "./linkTo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__